import { render, staticRenderFns } from "./formAutograph.vue?vue&type=template&id=6f1cd146&scoped=true"
import script from "./formAutograph.vue?vue&type=script&lang=js"
export * from "./formAutograph.vue?vue&type=script&lang=js"
import style0 from "./formAutograph.vue?vue&type=style&index=0&id=6f1cd146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1cd146",
  null
  
)

export default component.exports